export const SET_USER = "SET_USER";
export const SET_PROJECT = "SET_PROJECT";
export const LOG_OUT_USER = "LOG_OUT_USER";
